import { ISearchMembersInCompanyOutput } from '../models/interfaces/companyProfile/iSearchMembersInCompanyOutput'
import { INonprofitsByPageOutput } from '../models/interfaces/companyProfile/iNonprofitsByPageOutput';
import DataService from "../../../services/client/classes/dataService";
import { ICompanyActivitiesOutput } from "../models/interfaces/companyProfile/iCompanyActivitiesOutput";

class CompanyProfileService extends DataService {
    constructor() {
    super('/private/database/companyProfile/');
    }

  getCompanyProfileData(orgKey: string): JQuery.jqXHR<any> {

    return this.get('companyProfileData/', { orgKey });
  }

  searchMembersInCompany(search: ISearchMembersInCompanyOutput): JQuery.jqXHR<any> {
    return this.post('searchMembersInCompany/', search);
  }

  getSupportedNonprofits(data: INonprofitsByPageOutput): JQuery.jqXHR<any> {
    return this.get('getSupportedNonprofits/', data);
  }

  getMemberNonprofits(data: INonprofitsByPageOutput): JQuery.jqXHR<any> {
    return this.get('getMemberNonprofits/', data);
  }

    getCompanyActivities(data: ICompanyActivitiesOutput): JQuery.jqXHR<any> {
        return this.get('getCompanyActivities/', data);
    }

}

export default new CompanyProfileService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/companyProfileService.ts